(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[572],{

/***/ 3308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9521);
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2317);
/* harmony import */ var images_global_alert_white_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8171);
/* harmony import */ var images_global_alert_white_svg__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(images_global_alert_white_svg__WEBPACK_IMPORTED_MODULE_4__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  bottom: 0;\n  display: flex;\n  overflow: hidden;\n  width: 100%;\n  max-width: 350px;\n  height: 30px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0 0 0.8rem;\n  background: ",
        ";\n  .exclamationPoint {\n    position: absolute;\n    left: 10px;\n    width: 100%;\n    max-width: 19px;\n    height: 18px;\n    padding: 0;\n    margin: 0;\n    background: url(",
        ") no-repeat;\n  }\n  .messageText {\n    color: ",
        ";\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ErrorBanner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledErrorBanner, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "exclamationPoint"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "messageText",
                children: "Invalid activation code. Please try again."
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorBanner);
var StyledErrorBanner = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-ff3ac6ce-0"
})(_templateObject(), styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .fox.Monza */ .vn.Monza, (images_global_alert_white_svg__WEBPACK_IMPORTED_MODULE_4___default()), styles_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].white */ .ZP.white);


/***/ }),

/***/ 9584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_RegCodeInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(2317);
// EXTERNAL MODULE: ./styles/animations.ts
var animations = __webpack_require__(3167);
// EXTERNAL MODULE: ./styles/helper.ts + 1 modules
var helper = __webpack_require__(9900);
// EXTERNAL MODULE: ./lib/hooks/index.ts + 8 modules
var hooks = __webpack_require__(9434);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
;// CONCATENATED MODULE: ./lib/utils/regCode.ts

var isRegCode = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return value.length >= constants/* REG_CODE_MIN_LENGTH */.bl && constants/* REG_CODE_REGEX.test */.Ww.test(value);
};
var sanitizeRegCode = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return value.toUpperCase().replace(/[^A-Z0-9]/g, "");
};
// Takes a pathname, never location.href: href keeps the query string glued to
// the code until the trailing slash is normalized in. '' means "let them type".
var getRegCodeFromPath = function() {
    var pathname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!pathname.startsWith(constants/* PATH_ACTIVATE */.rr)) return "";
    var segments = pathname.slice(constants/* PATH_ACTIVATE.length */.rr.length).split("/").filter(Boolean);
    if (segments.length !== 1) return "";
    var code = segments[0].toUpperCase();
    return isRegCode(code) ? code : "";
};

// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var yup_index_esm = __webpack_require__(6310);
;// CONCATENATED MODULE: ./validations/schemas/RegCodeSchema.ts
// eslint-disable-next-line @typescript-eslint/no-var-requires
var yupResolver = (__webpack_require__(2433)/* .yupResolver */ .X);


var RegCodeSchema = function() {
    return yupResolver(yup_index_esm/* object */.Ry().shape({
        regCode: yup_index_esm/* string */.Z_().nullable().required("Reg code is required").min(constants/* REG_CODE_MIN_LENGTH */.bl, "Code must be at least ".concat(constants/* REG_CODE_MIN_LENGTH */.bl, " characters")).matches(constants/* REG_CODE_REGEX */.Ww, "Code must only contain letters and numbers")
    }).required());
};
/* harmony default export */ var schemas_RegCodeSchema = (RegCodeSchema);

// EXTERNAL MODULE: ./context/GlobalContextProvider.tsx
var GlobalContextProvider = __webpack_require__(1387);
// EXTERNAL MODULE: ./components/common/index.tsx + 6 modules
var common = __webpack_require__(2513);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./context/state/reducer.ts + 1 modules
var reducer = __webpack_require__(2807);
// EXTERNAL MODULE: ./lib/utils/helper.ts
var utils_helper = __webpack_require__(9981);
// EXTERNAL MODULE: ./lib/analytics/trackCalls.ts + 1 modules
var trackCalls = __webpack_require__(5537);
// EXTERNAL MODULE: ./lib/utils/index.ts + 3 modules
var utils = __webpack_require__(739);
// EXTERNAL MODULE: ./lib/hooks/useFlowManager.ts
var useFlowManager = __webpack_require__(9697);
;// CONCATENATED MODULE: ./components/RegCodeInput/hooks.ts














var useRegCodeInput = function(param) {
    var profile = param.profile, setRegCodeError = param.setRegCodeError;
    var ref = (0,react.useContext)(GlobalContextProvider/* AppContext */.I), state = ref.state, dispatch = ref.dispatch;
    var ref1 = (0,react.useState)(""), regCode = ref1[0], setRegCode = ref1[1];
    var ref2 = (0,hooks/* useBoolean */.kt)(false), error = ref2.value, setErrorTrue = ref2.setTrue, setErrorFalse = ref2.setFalse;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,useFlowManager/* default */.Z)(), cookies = ref3.cookies, setCookie = ref3.setCookie, removeCookie = ref3.removeCookie;
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(regCode) {
            var response, newAuthData, _tmp, firstScreenDeviceId, isAnonymous, isMvpd, isRegister, info, _tmp1, _tmp2, _tmp3, account, _tmp4, _tmp5, _tmp6, _tmp7, _tmp8, account1, _tmp9, _tmp10, _tmp11, _tmp12, e, info1, _tmp13, _tmp14, _tmp15, _tmp16;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setErrorFalse();
                        setRegCodeError(false);
                        removeCookie(constants/* COOKIE_CODE_INFO */.r5);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            13,
                            ,
                            14
                        ]);
                        return [
                            4,
                            (0,utils/* refreshToken */.g$)(profile, state === null || state === void 0 ? void 0 : state.account)
                        ];
                    case 2:
                        newAuthData = _state.sent();
                        _tmp = {};
                        return [
                            4,
                            profile.validateRegCode((_tmp.regCode = regCode, _tmp))
                        ];
                    case 3:
                        response = _state.sent();
                        firstScreenDeviceId = response.firstScreenDeviceId, isAnonymous = response.isAnonymous, isMvpd = response.isMvpd, isRegister = response.isRegister;
                        _tmp1 = {};
                        info = (0,_object_spread/* default */.Z)((_tmp1.code = regCode, _tmp1.deviceId = (0,utils_helper.uuidv4)(), _tmp1.type = constants/* CODE_TYPE_API */.Mp, _tmp1), response);
                        setRegCode(regCode);
                        _tmp2 = {};
                        (0,trackCalls/* handleTrackEvent */.GV)((_tmp2.eventName = trackCalls/* Events.PROFILE_INITIATED */.zW.PROFILE_INITIATED, _tmp2.props = {
                            page_activation_code: regCode
                        }, _tmp2));
                        if (!("nation" === constants/* Brand.NATION */.H2.NATION)) return [
                            3,
                            7
                        ];
                        _tmp3 = {};
                        setCookie(constants/* COOKIE_CODE_INFO */.r5, info, (_tmp3.path = "/", _tmp3));
                        _tmp4 = {};
                        return [
                            4,
                            profile === null || profile === void 0 ? void 0 : profile.loginAnonymously((_tmp4.deviceId = firstScreenDeviceId, _tmp4))
                        ];
                    case 4:
                        account = _state.sent();
                        dispatch((0,reducer/* setAccount */.hv)(newAuthData || account));
                        _tmp5 = {};
                        _tmp6 = {};
                        if (!newAuthData) {
                            (0,utils_helper.setAccountCookie)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp5, account), (_tmp6.idToken = "", _tmp6)));
                        }
                        if (!isMvpd) return [
                            3,
                            6
                        ];
                        dispatch((0,reducer/* setFlowStage */.Kc)(constants/* FLOW_STAGE_MVPD_SELECT */.Vr));
                        _tmp7 = {};
                        (0,trackCalls/* handleTrackEvent */.GV)((_tmp7.eventName = trackCalls/* Events.BUTTON_LINK_SELECTED */.zW.BUTTON_LINK_SELECTED, _tmp7.props = {
                            page_item_title: trackCalls/* Events.SUBMIT */.zW.SUBMIT,
                            page_destination_url: window.location.origin + constants/* ROUTE_MVPD */.W3
                        }, _tmp7));
                        return [
                            4,
                            router.push(constants/* ROUTE_MVPD */.W3)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        if (isAnonymous) {
                            window.location.href = "".concat((0,utils_helper.displayNationAccountEnvURL)(), "?code=").concat(regCode);
                            return [
                                2
                            ];
                        }
                        _state.label = 7;
                    case 7:
                        _tmp8 = {};
                        setCookie(constants/* COOKIE_CODE_INFO */.r5, info, (_tmp8.path = constants/* ROUTE_HOME */.XX, _tmp8));
                        dispatch((0,reducer/* setCodeInfo */.ys)(cookies[constants/* COOKIE_CODE_INFO */.r5]));
                        // Now & Sports flow
                        if (isRegister) dispatch((0,reducer/* setIsRegister */.ko)(isRegister));
                        if (!isMvpd) return [
                            3,
                            10
                        ];
                        _tmp9 = {};
                        return [
                            4,
                            profile === null || profile === void 0 ? void 0 : profile.loginAnonymously((_tmp9.deviceId = firstScreenDeviceId, _tmp9.additionalHeaders = {
                                "X-Delegated-Auth-Flow-Off": true
                            }, _tmp9))
                        ];
                    case 8:
                        account1 = _state.sent();
                        (0,utils_helper.setAccountCookie)(account1);
                        dispatch((0,reducer/* setFlowStage */.Kc)(constants/* FLOW_STAGE_MVPD_SELECT */.Vr));
                        _tmp10 = {};
                        (0,trackCalls/* handleTrackEvent */.GV)((_tmp10.eventName = trackCalls/* Events.BUTTON_LINK_SELECTED */.zW.BUTTON_LINK_SELECTED, _tmp10.props = {
                            page_item_title: trackCalls/* Events.SUBMIT */.zW.SUBMIT,
                            page_destination_url: window.location.origin + constants/* ROUTE_MVPD */.W3
                        }, _tmp10));
                        return [
                            4,
                            router.push(constants/* ROUTE_MVPD */.W3)
                        ];
                    case 9:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 10:
                        dispatch((0,reducer/* setFlowStage */.Kc)(constants/* FLOW_STAGE_PROFILE_AUTH */.T7));
                        // remove Anonymous Account Cookie to go get a Profile Account cookie
                        removeCookie(constants/* ACCOUNT_COOKIE_NAME_FOX */.EO);
                        _tmp11 = {};
                        _tmp12 = {};
                        (0,trackCalls/* handleTrackEvent */.GV)((_tmp11.eventName = trackCalls/* Events.BUTTON_LINK_SELECTED */.zW.BUTTON_LINK_SELECTED, _tmp11.props = {
                            page_item_title: trackCalls/* Events.SUBMIT */.zW.SUBMIT,
                            page_destination_url: window.location.origin
                        }, _tmp11), (_tmp12.eventName = trackCalls/* Events.SUBMIT_CODE_COMPLETED */.zW.SUBMIT_CODE_COMPLETED, _tmp12.props = {
                            page_active_code: regCode
                        }, _tmp12));
                        return [
                            4,
                            router.push(constants/* ROUTE_ACCOUNT */.I)
                        ];
                    case 11:
                        _state.sent();
                        _state.label = 12;
                    case 12:
                        return [
                            3,
                            14
                        ];
                    case 13:
                        e = _state.sent();
                        dispatch((0,reducer/* setError */.sT)(e));
                        dispatch((0,reducer/* setIsRegister */.ko)(false));
                        _tmp13 = {};
                        info1 = (0,_object_spread/* default */.Z)((_tmp13.code = regCode, _tmp13), response);
                        _tmp14 = {};
                        setCookie(constants/* COOKIE_CODE_INFO */.r5, info1, (_tmp14.path = constants/* ROUTE_HOME */.XX, _tmp14));
                        setRegCodeError(true);
                        setErrorTrue();
                        _tmp15 = {};
                        _tmp16 = {};
                        (0,trackCalls/* handleTrackEvent */.GV)((_tmp15.eventName = trackCalls/* Events.BUTTON_LINK_SELECTED */.zW.BUTTON_LINK_SELECTED, _tmp15.props = {
                            page_item_title: trackCalls/* Events.SUBMIT */.zW.SUBMIT,
                            page_destination_url: window.location.origin
                        }, _tmp15), (_tmp16.eventName = trackCalls/* Events.PROFILE_ACCESS_ACTIVATION_ERROR */.zW.PROFILE_ACCESS_ACTIVATION_ERROR, _tmp16.props = {
                            page_activation_code: regCode,
                            page_error_description: "no error description",
                            page_error_type: "invalid form input"
                        }, _tmp16));
                        return [
                            3,
                            14
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(regCode) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        regCode: regCode,
        setRegCode: setRegCode,
        handleSubmit: handleSubmit,
        error: error
    };
};
/* harmony default export */ var RegCodeInput_hooks = (useRegCodeInput);

;// CONCATENATED MODULE: ./components/RegCodeInput/index.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 200px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  input {\n    text-transform: uppercase;\n    padding: 0;\n    ",
        "\n    &:focus,\n    :active {\n      border: solid 2px ",
        ";\n    }\n    &::placeholder {\n      color: ",
        ";\n      text-transform: initial;\n      opacity: 0.5;\n    }\n    &.error {\n      border: solid 2px ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var RegCodeInput = function(param) {
    var profile = param.profile, setRegCodeError = param.setRegCodeError;
    var ref = (0,react.useContext)(GlobalContextProvider/* AppContext */.I), error = ref.state.error;
    var ref1 = RegCodeInput_hooks({
        profile: profile,
        setRegCodeError: setRegCodeError
    }), handleSubmitRegCode = ref1.handleSubmit;
    var isNation = (0,hooks/* useFlowManager */.ix)().isNation;
    var ref2 = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        reValidateMode: "onSubmit",
        resolver: schemas_RegCodeSchema(),
        defaultValues: {
            regCode: ""
        }
    }), control = ref2.control, handleSubmit = ref2.handleSubmit, setValue = ref2.setValue, isValid = ref2.formState.isValid;
    (0,react.useEffect)(function() {
        var code = getRegCodeFromPath(window.location.pathname);
        if (code) setValue("regCode", code, {
            shouldValidate: true
        });
    }, [
        setValue
    ]);
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleSubmitRegCode(sanitizeRegCode(data.regCode))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                    name: "regCode",
                    control: control,
                    render: function(param) {
                        var _field = param.field, name = _field.name, value = _field.value, onBlur = _field.onBlur, onChange = _field.onChange, ref = _field.ref;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Input */.II, {
                            ref: ref,
                            name: name,
                            value: value,
                            onBlur: onBlur,
                            onChange: function(event) {
                                return onChange(sanitizeRegCode(event.target.value));
                            },
                            placeholder: "Activation Code",
                            "aria-label": "Activation Code",
                            "aria-invalid": !!error,
                            autoCapitalize: "characters",
                            autoComplete: "off",
                            autoCorrect: "off",
                            spellCheck: false,
                            type: "text",
                            autoFocus: true,
                            className: error ? "error" : ""
                        });
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                    kind: isNation ? "secondary" : "default",
                    type: "submit",
                    disabled: !isValid,
                    children: "Submit"
                })
            ]
        })
    });
};
/* harmony default export */ var components_RegCodeInput = (RegCodeInput);
var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-5aa347ff-0"
})(_templateObject1(), animations/* fadein */.jF, helper/* respondTo.bp_768 */.s.bp_768(_templateObject()), colors/* fox.azureRadiance */.vn.azureRadiance, colors/* default.white */.ZP.white, colors/* default.error */.ZP.error);


/***/ }),

/***/ 5537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zW": function() { return /* binding */ Events; },
  "sn": function() { return /* binding */ PageNames; },
  "c7": function() { return /* binding */ PageTypes; },
  "Vk": function() { return /* binding */ handleAccountPageEvent; },
  "qH": function() { return /* binding */ handleHomePageEvent; },
  "GV": function() { return /* binding */ handleTrackEvent; },
  "jV": function() { return /* binding */ mountDataLayer; },
  "l9": function() { return /* binding */ setPageAnalyticsData; }
});

// UNUSED EXPORTS: EventTypes, generatePageName

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/Cookies.js
var Cookies = __webpack_require__(5501);
// EXTERNAL MODULE: ./lib/analytics/segment/index.ts + 2 modules
var segment = __webpack_require__(4292);
;// CONCATENATED MODULE: ./lib/analytics/index.ts

var initiated = false;
var LCP_TIME = 6000;
var init = function() {
    window.segmentFlushQueue = flushQueue;
    if (initiated) return true;
    initSegment();
    initiated = true;
    window.addEventListener("unload", function() {
        flushQueue();
    });
    return initiated;
};
var handleAnalytics = function(event) {
    (0,segment/* segmentTrackEvent */.R7)(event);
};
var timedOutInit = function() {
    if (initiated) return true;
    setTimeout(function() {
        return init();
    }, LCP_TIME);
    return true;
};

// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
// EXTERNAL MODULE: ./lib/utils/helper.ts
var helper = __webpack_require__(9981);
// EXTERNAL MODULE: ./lib/utils/getConfig.ts + 1 modules
var getConfig = __webpack_require__(889);
;// CONCATENATED MODULE: ./lib/analytics/trackCalls.ts








var EventTypes;
(function(EventTypes) {
    EventTypes["PAGE"] = "page";
    EventTypes["TRACK"] = "track";
})(EventTypes || (EventTypes = {}));
var Events;
(function(Events) {
    Events["BUTTON_LINK_SELECTED"] = "Button Link Selected";
    Events["SUBMIT"] = "Submit";
    Events["SUBMIT_CODE_LANDING"] = "Submit Code Landing";
    Events["SUBMIT_CODE_STARTED"] = "Submit Code Started";
    Events["SUBMIT_CODE_COMPLETED"] = "Submit Code Completed";
    Events["PROFILE_ACCESS_ACTIVATION_STARTED"] = "Profile Access Activation Started";
    Events["PROFILE_ACCESS_ACTIVATION_COMPLETED"] = "Profile Access Activation Completed";
    Events["PROFILE_ACCESS_ACTIVATION_ERROR"] = "Profile Access Activation Error";
    Events["PROFILE_INITIATED"] = "Profile Initiated";
    Events["PROFILE_PROMPT_LANDING"] = "Profile Prompt Landing";
    Events["PROFILE_SIGN_IN_STARTED"] = "Profile Sign In Started";
    Events["PROFILE_SIGN_UP_STARTED"] = "Profile Sign Up Started";
    Events["PROFILE_SIGN_IN_COMPLETED"] = "Profile Sign In Completed";
    Events["PROFILE_SIGN_UP_COMPLETED"] = "Profile Sign Up Completed";
})(Events || (Events = {}));
var FOX_PREFIX = "delta";
var NATION_PREFIX = "nation";
var SPORT_PREFIX = "nation sport";
var PageNames;
(function(PageNames) {
    PageNames["SUBMIT_CODE_LANDING"] = "submit code landing";
    PageNames["PROFILE_PROMPT_LANDING"] = "profile prompt:landing";
})(PageNames || (PageNames = {}));
var PageTypes;
(function(PageTypes) {
    PageTypes["ACTIVATION_CODE"] = "activation code";
    PageTypes["PROFILE_PROMPT"] = "profile prompt";
})(PageTypes || (PageTypes = {}));
var _obj;
var getClientPrefix = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* Brand.FOX */.H2.FOX, FOX_PREFIX), (0,_define_property/* default */.Z)(_obj, constants/* Brand.SPORTS */.H2.SPORTS, SPORT_PREFIX), (0,_define_property/* default */.Z)(_obj, constants/* Brand.NATION */.H2.NATION, NATION_PREFIX), _obj);
var ACTIVATION_METHOD = "2nd screen";
var APP_PLATFORM = "web";
var FOX = "fox";
var FOX_DOMAIN = "fox.com";
var NATION_DOMAIN = "foxnews.com";
var ANONYMOUS_ID_COOKIE = "lastAnonymousProfileId";
var PAGE_TYPE = "ott";
var PRIMARY_BUSINESS_UNIT = "fng";
var PROFILE_ID_COOKIE = "secondScreenProfileId";
var START_SOURCE = "general";
var APP_CLIENT_PREFIX = getClientPrefix["nation"];
var defaultTraits = {
    appsflyer_id: "",
    dcg_profile_id: "",
    lastAnonymousProfileId: "",
    lastKnownProfileId: "",
    mvpd: "",
    network_entitlement_list: "",
    us_privacy: ""
};
// TODO: Update BRAND and DEVICE for Nation
// const DEVICE = account?.device ?? 'FOX';
var BRAND = FOX;
var DEVICE = "FOX";
var defaultProps = {
    app_name: "nation" || 0,
    app_platform: APP_PLATFORM,
    // TODO: set app version dynamically
    app_version: "1.0.0",
    page_name: ACTIVATION_METHOD,
    page_profile_activation_method: ACTIVATION_METHOD,
    page_start_source: START_SOURCE,
    page_type: PAGE_TYPE,
    primary_business_unit: PRIMARY_BUSINESS_UNIT,
    secondary_business_unit: "nation" || 0
};
var handleTrackEvent = function() {
    for(var _len = arguments.length, events = new Array(_len), _key = 0; _key < _len; _key++){
        events[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _step.value, eventName = _value.eventName, props = _value.props, context = _value.context, eventType = _value.eventType;
            var ref, ref1;
            var cookies = new Cookies/* default */.Z();
            var ref2;
            var profileId = (ref2 = cookies.get(PROFILE_ID_COOKIE)) !== null && ref2 !== void 0 ? ref2 : "";
            var ref3;
            var codeInfoCookie = (ref3 = cookies.get(constants/* COOKIE_CODE_INFO */.r5)) !== null && ref3 !== void 0 ? ref3 : {};
            var campaignCodes = fetchCampaignCodes();
            // TODO: Find out why campaignCodes are different for different events
            if (eventName === Events.PROFILE_ACCESS_ACTIVATION_COMPLETED) {
                var ref4;
                var compaignCodesCookie = (ref4 = cookies.get(constants/* COOKIE_CAMPAIGN_CODES */.gV)) !== null && ref4 !== void 0 ? ref4 : "";
                campaignCodes = parseCampaignParams(compaignCodesCookie);
            }
            var traits = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultTraits, campaignCodes), {
                dcg_profile_id: profileId,
                lastAnonymousProfileId: getAnonymousId(),
                lastKnownProfileId: profileId
            });
            var ref5;
            var argsPageName = (ref5 = props === null || props === void 0 ? void 0 : props.page_name) !== null && ref5 !== void 0 ? ref5 : null;
            var ref6;
            var currentPageName = (ref6 = (ref = window.DataLayer) === null || ref === void 0 ? void 0 : ref.page_name) !== null && ref6 !== void 0 ? ref6 : null;
            var pageName = argsPageName !== null && argsPageName !== void 0 ? argsPageName : currentPageName;
            var genericPageName = generatePageName({
                pageName: pageName
            });
            var ref7;
            var argsPageType = (ref7 = props === null || props === void 0 ? void 0 : props.page_type) !== null && ref7 !== void 0 ? ref7 : null;
            var ref8;
            var currentPageType = (ref8 = (ref1 = window.DataLayer) === null || ref1 === void 0 ? void 0 : ref1.page_type) !== null && ref8 !== void 0 ? ref8 : null;
            var pageType = argsPageType !== null && argsPageType !== void 0 ? argsPageType : currentPageType;
            var ref9;
            var argsActivationCode = (ref9 = props === null || props === void 0 ? void 0 : props.page_activation_code) !== null && ref9 !== void 0 ? ref9 : null;
            var _code;
            var currentActiovationCode = (_code = codeInfoCookie.code) !== null && _code !== void 0 ? _code : null;
            var activationCode = argsActivationCode !== null && argsActivationCode !== void 0 ? argsActivationCode : currentActiovationCode;
            var newContext = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, context), {
                traits: traits
            });
            var finalProps = (0,helper.cleanObject)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultProps), {
                page_name: genericPageName,
                page_type: pageType,
                page_activation_code: activationCode
            }), props));
            handleAnalytics({
                eventName: eventName,
                props: finalProps,
                eventType: eventType,
                context: newContext
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var generatePageName = function(param) {
    var pageName = param.pageName;
    return "".concat(APP_CLIENT_PREFIX, ":").concat(APP_PLATFORM, ":").concat(pageName);
};
var handleHomePageEvent = function() {
    handleTrackEvent({
        eventName: Events.PROFILE_ACCESS_ACTIVATION_STARTED
    }, {
        eventName: Events.SUBMIT_CODE_STARTED
    }, {
        eventName: Events.SUBMIT_CODE_LANDING,
        eventType: EventTypes.PAGE
    });
};
var handleAccountPageEvent = function() {
    handleTrackEvent({
        eventName: Events.PROFILE_PROMPT_LANDING,
        eventType: EventTypes.PAGE
    });
};
var getAnonymousId = function() {
    var ref;
    var cookies = new Cookies/* default */.Z();
    var user = (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.user;
    var ref1;
    var lastAnonymousProfileId = (ref1 = cookies.get(ANONYMOUS_ID_COOKIE)) !== null && ref1 !== void 0 ? ref1 : "";
    var networkDomain;
    if (BRAND === FOX) networkDomain = FOX_DOMAIN;
    else networkDomain = NATION_DOMAIN;
    if (lastAnonymousProfileId) {
        cookies.set(ANONYMOUS_ID_COOKIE, lastAnonymousProfileId, {
            domain: networkDomain
        });
        return lastAnonymousProfileId;
    }
    var anonymousId = user ? user().anonymousId() : null;
    // TODO: Finds out why it is here
    cookies.set(ANONYMOUS_ID_COOKIE, anonymousId, {
        domain: networkDomain
    });
    return anonymousId;
};
var mountDataLayer = function() {
    window.DataLayer = {};
};
var setPageAnalyticsData = function(param) {
    var pageName = param.pageName, pageType = param.pageType;
    if (!window.DataLayer) mountDataLayer();
    window.DataLayer.page_name = pageName;
    window.DataLayer.page_type = pageType;
};
var parseCampaignParams = function(queryString) {
    if (!queryString) return {};
    var cleanQueryString = queryString.split("undefinedUnknown")[0];
    var segmentCampaign = "cmpid";
    var propertyNames = {
        cmpid: "campaign_int_tracking_code",
        int_cmp: "campaign_int_name"
    };
    var params = {};
    var ref;
    var cleanCampaignString = (ref = cleanQueryString.match(/^[^&]*/)) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var campaignString = (ref1 = cleanCampaignString[0]) !== null && ref1 !== void 0 ? ref1 : "";
    params[propertyNames[segmentCampaign]] = campaignString;
    var campaignCodes = campaignString.split("::");
    (campaignCodes || []).forEach(function(codes) {
        var keyValuesPair = codes.split("=");
        if (keyValuesPair.length === 2) {
            var ref;
            var key = (ref = keyValuesPair[0]) !== null && ref !== void 0 ? ref : "";
            var ref1;
            var value = (ref1 = keyValuesPair[1]) !== null && ref1 !== void 0 ? ref1 : "";
            var _key;
            var property = (_key = propertyNames[key]) !== null && _key !== void 0 ? _key : "";
            params[property] = value;
        }
    });
    return (0,helper.cleanObject)(params);
};
var fetchCampaignCodes = function() {
    var ref;
    var intCmp = (ref = getParameterByName(constants/* INT_CMP */.vl)) !== null && ref !== void 0 ? ref : null;
    // if (intCmp == null) return null;
    var intOrg = "dcg";
    // TODO: Get brand from
    var intMc = BRAND;
    var ref1;
    var intSrc = (ref1 = getDeviceFromProvidersByKey()) !== null && ref1 !== void 0 ? ref1 : DEVICE;
    var intAdd = intMc + (intSrc ? "_" + intSrc : "") + (intCmp ? "_" + intCmp : "");
    var codes = (0,helper.cleanObject)({
        int_org: intOrg,
        int_mc: intMc !== null && intMc !== void 0 ? intMc : null,
        int_src: intSrc !== null && intSrc !== void 0 ? intSrc : null,
        int_cmp: intCmp !== null && intCmp !== void 0 ? intCmp : null,
        int_add: intAdd !== null && intAdd !== void 0 ? intAdd : null
    });
    codes.campaign_int_tracking_code = formatCampaignString(codes);
    return codes;
};
var getParameterByName = function getParameterByName(name) {
    var match = RegExp("[?&]" + name + "=([^&]*)").exec(window === null || window === void 0 ? void 0 : window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
};
var formatCampaignString = function(campaignCodes) {
    var campaignKeys = Object.keys(campaignCodes);
    return campaignKeys.reduce(function(acc, key, i) {
        var isLast = i === campaignKeys.length - 1;
        return acc + key + "=" + campaignCodes[key] + (!isLast ? "::" : "");
    }, "");
};
var getDeviceFromProvidersByKey = function() {
    var cookies = new Cookies/* default */.Z();
    var ref;
    var codeInfoCookie = (ref = cookies.get(constants/* COOKIE_CODE_INFO */.r5)) !== null && ref !== void 0 ? ref : "";
    var config = (0,getConfig/* getConfig */.i)();
    var ref1;
    var devices = (ref1 = config === null || config === void 0 ? void 0 : config.devices) !== null && ref1 !== void 0 ? ref1 : [];
    Object.entries(devices).forEach(function(element) {
        var deviceName = element[0];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var providerKeys = element[1]["providers-key"];
        if (providerKeys === codeInfoCookie || deviceName === providerKeys) return element;
    });
    return null;
};


/***/ }),

/***/ 8171:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMThweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMTggMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvRG93bmxvYWRzL0FjdGlvbnMvRG93bmxvYWQgRXJyb3IvMTg8L3RpdGxlPgogICAgPGcgaWQ9Ikljb25zL0Rvd25sb2Fkcy9BY3Rpb25zL0Rvd25sb2FkLUVycm9yLzE4IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNOSwwIEMxMy45NzA1NjI3LDAgMTgsNC4wMjk0MzcyNSAxOCw5IEMxOCwxMy45NzA1NjI3IDEzLjk3MDU2MjcsMTggOSwxOCBDNC4wMjk0MzcyNSwxOCAwLDEzLjk3MDU2MjcgMCw5IEMwLDQuMDI5NDM3MjUgNC4wMjk0MzcyNSwwIDksMCBaIE05LDEuMjUgQzQuNzE5NzkzMTksMS4yNSAxLjI1LDQuNzE5NzkzMTkgMS4yNSw5IEMxLjI1LDEzLjI4MDIwNjggNC43MTk3OTMxOSwxNi43NSA5LDE2Ljc1IEMxMy4yODAyMDY4LDE2Ljc1IDE2Ljc1LDEzLjI4MDIwNjggMTYuNzUsOSBDMTYuNzUsNC43MTk3OTMxOSAxMy4yODAyMDY4LDEuMjUgOSwxLjI1IFogTTEwLDEyIEwxMCwxNCBMOCwxNCBMOCwxMiBMMTAsMTIgWiBNMTAsNCBMMTAsMTEgTDgsMTEgTDgsNCBMMTAsNCBaIiBpZD0iRXJyb3IiIGZpbGw9IiNmZmZmZmYiPjwvcGF0aD4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ })

}]);